export default "__VITE_ASSET__CL7RXyXl__"